export default __webpack_public_path__ + "static/media/full-logo.8acffc73.png";